
import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4q3a2ir20r5k3vfkmug', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          company: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="iletisim" className="relative py-32 min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/03c2f72aca2243e3faba94215e88949f.jpg"
          alt="İletişim"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#2D3436]/75"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="text-6xl font-bold text-white mb-8 lowercase leading-tight">
              hemen başlayın
              <br />
              projelerinizde
            </h2>
            <p className="text-xl text-white/90 font-light leading-relaxed mb-12">
              Uzman ekibimizle tanışın ve işletmeniz için en uygun çözümleri birlikte belirleyelim. Size özel teklif hazırlamak için formu doldurun.
            </p>
            
            {/* Contact Info Cards */}
            <div className="space-y-4 mb-12">
              <a 
                href="tel:+905543791632"
                className="flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-4 rounded-xl hover:bg-white/20 transition-all cursor-pointer group"
              >
                <div className="w-12 h-12 bg-[#C17F59] rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-white/70 text-xs font-medium mb-1">Telefon</p>
                  <p className="text-white font-semibold">+90 554 379 16 32</p>
                </div>
              </a>

              <a 
                href="mailto:kgmdanismanlik@gmail.com"
                className="flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-4 rounded-xl hover:bg-white/20 transition-all cursor-pointer group"
              >
                <div className="w-12 h-12 bg-[#C17F59] rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-white/70 text-xs font-medium mb-1">E-posta</p>
                  <p className="text-white font-semibold">kgmdanismanlik@gmail.com</p>
                </div>
              </a>

              <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-4 rounded-xl">
                <div className="w-12 h-12 bg-[#C17F59] rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-white/70 text-xs font-medium mb-1">Adres</p>
                  <p className="text-white font-semibold">Konya, Türkiye</p>
                </div>
              </div>
            </div>

            <a
              href="https://wa.me/905543791632?text=Merhaba,%20hizmetleriniz%20hakkında%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-[#C17F59] text-white px-8 py-4 rounded-full font-medium hover:bg-[#A66B47] transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-2xl mr-3"></i>
              <span>WhatsApp ile İletişime Geç</span>
            </a>
          </div>

          <div id="iletisim-form" className="bg-white rounded-3xl p-10 shadow-2xl">
            <h3 className="text-3xl font-bold text-[#2D3436] mb-6">İletişim Formu</h3>
            <p className="text-gray-600 mb-8">Formu doldurun, en kısa sürede size dönüş yapalım.</p>

            <form onSubmit={handleSubmit} data-readdy-form id="contact-form">
              <div className="space-y-5">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="Adınız Soyadınız *"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-[#C17F59] focus:outline-none transition-colors text-sm"
                  />
                </div>

                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="E-posta Adresiniz *"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-[#C17F59] focus:outline-none transition-colors text-sm"
                  />
                </div>

                <div>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Telefon Numaranız *"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-[#C17F59] focus:outline-none transition-colors text-sm"
                  />
                </div>

                <div>
                  <input
                    type="text"
                    name="company"
                    placeholder="Firma Adı"
                    value={formData.company}
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                    className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-[#C17F59] focus:outline-none transition-colors text-sm"
                  />
                </div>

                <div>
                  <select
                    name="service"
                    required
                    value={formData.service}
                    onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                    className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-[#C17F59] focus:outline-none transition-colors text-sm cursor-pointer"
                  >
                    <option value="">Hizmet Seçiniz *</option>
                    <option value="devlet-izinleri">Devlet İzinleri ve Yasal Süreçler</option>
                    <option value="urun-belgelendirme">Ürün Belgelendirme ve İhracat</option>
                    <option value="yatirim-danismanlik">Yatırım ve Kurulum Danışmanlığı</option>
                    <option value="yonetim-sistemleri">Yönetim Sistemleri (ISO)</option>
                    <option value="yazilim">Özel Yazılım Çözümleri</option>
                    <option value="kalibrasyon">Kalibrasyon Hizmetleri</option>
                  </select>
                </div>

                <div>
                  <textarea
                    name="message"
                    placeholder="Mesajınız"
                    rows={4}
                    maxLength={500}
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-[#C17F59] focus:outline-none transition-colors resize-none text-sm"
                  ></textarea>
                  <div className="text-xs text-gray-500 mt-1 text-right">
                    {formData.message.length}/500
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#C17F59] text-white py-4 rounded-xl font-medium hover:bg-[#A66B47] transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  {isSubmitting ? 'Gönderiliyor...' : 'Gönder'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl text-sm">
                    Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm">
                    Bir hata oluştu. Lütfen daha sonra tekrar deneyin.
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
